import axios, { CanceledError } from 'axios';

interface GetAutocompleteOptions {
    signal?: AbortSignal;
}

function useSearchService(link?: string) {
    async function getAutocomplete(keyword: string, options?: GetAutocompleteOptions): Promise<string[]> {
        try {
            const response = await axios.get<string[]>(link + keyword, { signal: options?.signal });
            return response.data || [];
        } catch (e) {
            if (!(e instanceof CanceledError)) {
                console.log(e);
            }
            return [];
        }
    }

    return {
        getAutocomplete
    };
}

export default useSearchService;
